<template>
    <div class="wrap">
        <listHeader
            :title="postData.ssid > 0 ? '编辑学生' : '新增学生'"
            :back="true"></listHeader>

        <div class="wrap-list-content">

            <div class="wrap-form-info">
                <a-row>
                    <a-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
                        <a-form :form="form">

                            <a-form-item
                                label="学生姓名"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请输入学生姓名" v-decorator="['ssname', {rules: [{ required: true, max: 64, message: '请输入学生姓名' }], initialValue: ''}]"/>
                            </a-form-item>

                            <a-form-item
                                label="手机号"
                                v-bind="formItemLayout"
                                required
                            >
                                <a-input placeholder="请填写手机号"
                                         v-decorator="['mobile', {rules: [{ required: true, validator: requiredMobile,  message: '请填写正确的手机号' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                label="身份证"
                                v-bind="formItemLayout"
                            >
                                <a-input placeholder="请填写身份证"
                                         v-decorator="['idcard', {rules: [{ required: false, validator: checkIdcard,  message: '请填写正确的身份证号码' }]} ]"/>
                            </a-form-item>

                            <a-form-item
                                v-bind="formBtnLayout"
                            >
                                <a-button type="primary" @click="create">确定</a-button>
                            </a-form-item>
                        </a-form>
                    </a-col>
                </a-row>
            </div>
        </div>
    </div>
</template>

<script>
import listHeader from '@/components/list/listHeader';

export default {
    components: {
        listHeader,
    },
    data() {
        return {
            scenario: 'studentCreate',
            visible: false, // 是否显示图片src
            formItemLayout: {
                labelCol: {
                    span: 5
                },
                wrapperCol: {
                    span: 19
                },
            },
            formBtnLayout: {
                wrapperCol: {
                    span: 19,
                    offset: 5,
                },
            },
            form: this.$form.createForm(this),
            postData: {
                'sid': '',
                'scid': '',
                'ssid': '',
            },
            data: {},
            config: {},
        }
    },
    Watch: {
    },
    created() {
        this.setData();
        this.getData();
    },
    methods: {
        setData() {
            for (let i in this.postData) {
                if (this.$route.query[i] === undefined) continue;
                this.postData[i] = this.$route.query[i];
            }
        },
        getData() {
            // 查询数据
            this.http('/manage/student/info', this.postData, (res) => {
                this.data = res.data;
                this.config = res.config;

                if (res.data.ssid) {
                    this.$nextTick(() => {
                        this.form.setFieldsValue({
                            ssname: res.data.ssname,
                            mobile: res.data.mobile,
                            idcard: res.data.idcard,
                        });
                    });
                }

            }, null, 2);
        },
        create() {
            this.form.validateFields(
                (errors, values) => {
                    if (!errors) {
                        let url = '';
                        if(this.postData.ssid > 0) {
                            url = '/manage/student/edit';
                            values.ssid = this.postData.ssid;
                        } else {
                            url = '/manage/student/save';
                            values.scid = this.postData.scid;
                            values.sid = this.postData.sid;
                        }

                        this.http(url, values, (res) => {
                            this.toast({content: '操作成功'}, (res) => {
                                this.$router.go(-1);
                            });
                        }, null, 1);
                    }
                }
            );
        },
    },
}
</script>

<style lang="less" src="../../assets/css/add/add.less"></style>
